/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
// import InshaHeader from "./InshaHeader";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// import InshaFooter from "./InshaFooter";
// import InshaHeaderLink from "./InshaHeaderLink";
import Header from "views/Main/MainHeader.js";
import Footer from "views/Main/MainFooter.js";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Button from "components/CustomButtons/Button.js";
// import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import ShippingDescription from "views/Main/ShippingDescription";
// import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
// import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);
const useStyleHead = makeStyles(headersStyle);

export default function Shipping() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();
  const classHead = useStyleHead();

  return (
    <div>
      <Helmet>
        <title>Shipping</title>
        <meta
          name="description"
          content="Omega Bangles Shipping If you are not satisfied with your purchase, you can return the product and get a full refund or exchange the product for another one, be it similar or 
          Product return will be accepted in case of damage on receipt or difference in product design from that on the website.
          "
        />
        <meta name="keywords" content="Omega Bangles Shipping" />
      </Helmet>
      <Header
        absolute
        // fixed
        brand="Home"
        color="transparent"
        links={
          <div className={classHead.collapse}>
            <List className={classHead.list + " " + classHead.mlAuto}>
              <ListItem className={classHead.listItem}>
                <Button
                  className={classHead.navLink}
                  onClick={(e) => e.preventDefault()}
                  color="transparent"
                >
                  Help
                </Button>
              </ListItem>
              <ListItem className={classHead.listItem}>
                <Button
                  className={classHead.navLink}
                  onClick={(e) => e.preventDefault()}
                  color="transparent"
                >
                  Message
                </Button>
              </ListItem>
              <ListItem className={classHead.listItem}>
                <Button
                  className={classHead.navLink}
                  onClick={(e) => e.preventDefault()}
                  color="transparent"
                >
                  Sign In
                </Button>
              </ListItem>
            </List>
          </div>
        }
      />
      <Parallax
        image={require("assets/img/bg2.png").default}
        filter="dark"
        small
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter
              )}
            >
              <h1 style={{ color: "#fff", fontFamily: "Tahoma", fontWeight: "bold" }}>Shipping</h1>
              <h4 style={{ color: "#fff" }}>
                Your satisfaction important to us...
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ShippingDescription />
          {/* <SectionTeam /> */}
          {/* <SectionOffice /> */}
          <br />
        </div>
      </div>
      <br />
      <br />
      <Footer />
    </div>
  );
}